export default __webpack_public_path__ + "static/media/dummy.14b66b3a.svg";